// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"cW","product":"dW","products":"eW","tooltipWrapper":"fW","tooltip":"gW","title":"hW"};